import { render, staticRenderFns } from "./InventoryGTINDetail.vue?vue&type=template&id=4c12fc46&scoped=true&"
import script from "./InventoryGTINDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryGTINDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryGTINDetail.vue?vue&type=style&index=0&id=4c12fc46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c12fc46",
  null
  
)

export default component.exports